"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var http_1 = require("../http");
var common_class_1 = require("../http/common_class");
exports.globalSwitcherAPIPath = 'v1/activated/';
var GlobalSwitcherHttp = /** @class */ (function (_super) {
    __extends(GlobalSwitcherHttp, _super);
    function GlobalSwitcherHttp(config) {
        var _this = _super.call(this, config) || this;
        _this.getActivated =
            http_1.createHttpGetFunction("" + _this.baseAPIPath + exports.globalSwitcherAPIPath)(_this.client);
        return _this;
    }
    GlobalSwitcherHttp.prototype.isGlobalActivated = function () {
        return this.getActivated(__assign({}, this.baseUri, { logger: this.logger }));
    };
    return GlobalSwitcherHttp;
}(common_class_1.CommonHttpClass));
exports.GlobalSwitcherHttp = GlobalSwitcherHttp;
//# sourceMappingURL=index.js.map